import { useCallback } from 'react';

import Analytics, { ElementShownAnchor } from '@hh.ru/analytics-js';
import { Button, Card, Text, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';
import { ElementSpyInstance } from 'bloko/common/elementSpy';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Notices from 'Modules/Notices';
import translation from 'src/components/translation';

import styles from './styles.less';

const TrlKeys = {
    title: 'vacancy.search.setka.banner.title',
    description: 'vacancy.search.setka.banner.description',
    button: 'vacancy.search.setka.banner.button',
};

const BANNER_NAME = 'vacancy_search_setka_banner';
// eslint-disable-next-line
const BANNER_LINK = 'https://4284841.redirect.appmetrica.yandex.com/?appmetrica_tracking_id=533228366812154364&utm_medium=banner&utm_source=site_hh&utm_campaign=poisk';

const bannerShownAnalytics = (element: HTMLElement): ElementSpyInstance =>
    Analytics.sendHHEventElementShown(element, {
        name: BANNER_NAME,
    });

const SetkaBanner: TranslatedComponent = ({ trls }) => {
    const { isMobile } = useBreakpoint();

    const handleButtonClick = useCallback(() => {
        Notices.markAsViewed(BANNER_NAME);
        Analytics.sendHHEventButtonClick(BANNER_NAME);
        window.open(BANNER_LINK);
    }, []);

    const handleBannerClick = useCallback(() => {
        Notices.markAsViewed(BANNER_NAME);
        Analytics.sendHHEventButtonClick(BANNER_NAME, {
            fromBanner: true,
        });
        window.open(BANNER_LINK, '_blank');
    }, []);

    return (
        <>
            <ElementShownAnchor fn={bannerShownAnalytics}>
                <Card
                    onClick={isMobile ? undefined : handleBannerClick}
                    style="secondary"
                    padding={isMobile ? 16 : 8}
                    borderRadius={isMobile ? 28 : 32}
                    stretched
                >
                    <div className={styles.setkaContainer}>
                        <Card style="secondary" padding={isMobile ? 12 : 20}>
                            <Text typography="title-5-semibold">{trls[TrlKeys.title]}</Text>
                            <VSpacing default={4} />
                            <Text>{trls[TrlKeys.description]}</Text>
                        </Card>
                        {!isMobile && <div className={styles.setkaQr} />}
                    </div>
                    {isMobile && (
                        <>
                            <VSpacing default={16} />
                            <Button mode="primary" style="neutral" size="medium" onClick={handleButtonClick} stretched>
                                {trls[TrlKeys.button]}
                            </Button>
                        </>
                    )}
                </Card>
            </ElementShownAnchor>
            <VSpacing default={16} />
        </>
    );
};

export default translation(SetkaBanner);
